import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  currentPage: 1,
  limit: 20,
  hasMore: false,
  categoryId: null,
  subCategoryId: null,
};

const categoryProductSlice = createSlice({
  name: "ecomProduct",
  initialState,
  reducers: {
    setCategoryProducts(state, action) {
      state.products = [...state.products, ...action.payload];
    },
    resetCategoryProducts(state) {
      state.products = [];
      state.currentPage = 1;
      state.hasMore = false;
    },
    resetAllCategoryProductsData(state) {
      state.products = [];
      state.currentPage = 1;
      state.hasMore = false;
      state.limit = 20;
      state.categoryId = null;
      state.subCategoryId = null;
    },
    incrementCategoryPage(state) {
      state.currentPage += 1;
    },
    setCategoryHasMore(state, action) {
      state.hasMore = action.payload;
    },
    setCategoryId(state, action) {
      state.categoryId = action.payload;
    },
    setSubCategoryId(state, action) {
      state.subCategoryId = action.payload;
    },
  },
});

export const {
  setCategoryProducts,
  resetCategoryProducts,
  incrementCategoryPage,
  setCategoryHasMore,
  setCategoryId,
  setSubCategoryId,
  resetAllCategoryProductsData,
} = categoryProductSlice.actions;

export default categoryProductSlice.reducer;
